<template>
    <div class="user-panel">
        <div class="logo-wrap">
            <img alt="F&B Logo" src="../../assets/logo.png">
        </div>
        <h1>Witaj, {{user.influencer.nick}}<span class="purple-text">.</span></h1>
        <div class="confirm-info" v-if="!user.confirmed">
            <h4>Twoje konto jest nieaktywne!</h4>
            <span>Kliknij w link aktywacyjny, który wysłaliśmy na Twój adres email: <strong>{{user.influencer.email}}</strong></span>
        </div>
        <div class="confirm-info" v-if="user.confirmed">
            <h4>Twoje konto jest aktywne!</h4>
        </div>
        <button class="submit-purple-button" v-on:click="handleLogout" type="button">Wyloguj</button>
    </div>
</template>

<script>
    import StepDeliveryData from "../Steps/StepDeliveryData";
    import Router from "../../routing";

    export default {
        name: "UserPanel",
        components: {StepDeliveryData},
        props: ["user"],
        methods: {
            handleLogout: function () {
                Router.logout();
            }
        }
    }
</script>

<style scoped lang="scss">

    h1 {
        margin-top: 40px;
    }

    button {
        margin-top: 50px;
    }

    .confirm-info {
        padding-top: 20px;

        span {
            line-height: 25px;
        }
    }

    .user-panel {
        padding-left: 10px;
        padding-right: 10px;

        text-align: center;
    }

    .logo-wrap {
        margin-top: 16px;
        text-align: center;

        img {
            max-width: 150px;
            min-width: 100px;
            width: 30vw;
        }
    }

    h1 {
        text-align: center;
    }
</style>